// extracted by mini-css-extract-plugin
module.exports = {"rich-text-full":"RichTextFull_rich-text-full__4kzQS"};